import api from "@/services/api/participantDashboard.js";
import { immerable } from "immer"
import { useState } from 'react'

class UseOrg {

	[immerable] = true

	constructor(params) {
		this.appointmentEmail = params.appointmentEmail
		this.appointmentIdNumber = params.appointmentIdNumber
		this.appointmentMobile = params.appointmentMobile
		this.appointmentName = params.appointmentName
		this.appointmentNationality = params.appointmentNationality
		this.appointmentPosition = params.appointmentPosition
		this.companyStatus = params.companyStatus
		this.companyType = params.companyType
		this.countryofIncorporation= params.countryofIncorporation
		this.createdBy= params.createdBy
		this.created= params.created
		this.dataSharingUrl = params.dataSharingUrl
		this.description = params.description
		this.domain = params.domain
		this.email = params.email
		this.enrolmentDataSource = params.enrolmentDataSource
		this.enrolmentQUrl =  params.enrolmentQUrl
		this.iconUrl = params.iconUrl
		this.incorporationDate = params.incorporationDate
		this.industry = params.industry
		this.modified = params.modified
		this.modifiedBy = params.modifiedBy
		this.name = params.name
		this.orgId = params.orgId
		this.orgKmsId = params.orgKmsId
		this.orgType = params.orgType
		this.registeredAddress = params.registeredAddress
		this.status = params.status
		this.ttKeyId = params.ttKeyId
		this.uen = params.uen
	}
}

const useOrgData = (queryParam) => {

	const [items, setItems] = useState([])
	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.getOrgData(params)
		setLoading(false)

		if (error) {
			return setError(error)
		}

		const serializedData = serialize(data)
		const newItems = new UseOrg(serializedData)
		return setItems(newItems)
	}

	function serialize(entry) {
		return {
			appointmentEmail: entry.appointmentEmail,
			appointmentIdNumber: entry.appointmentIdNumber,
			appointmentMobile: entry.appointmentMobile,
			appointmentName: entry.appointmentName,
			appointmentNationality: entry.appointmentNationality,
			appointmentPosition: entry.appointmentPosition,
			companyStatus: entry.companyStatus,
			companyType: entry.companyType,
			countryofIncorporation: entry.countryofIncorporation,
			created: entry.created,
			createdBy: entry.createdBy,
			description: entry.description,
			dataSharingUrl: entry.dataSharingUrl,
			domain: entry.domain,
			email: entry.email,
			enrolmentDataSource: entry.enrolmentDataSource,
			enrolmentQUrl: entry.enrolmentQUrl,
			iconUrl: entry.iconUrl,
			incorporationDate: entry.incorporationDate,
			industry: entry.industry,
			modified: entry.modified,
			modifiedBy: entry.modifiedBy,
			name: entry.name,
			orgId: entry.orgId,
			orgKmsId: entry.orgKmsId,
			orgType: entry.orgType,
			registeredAddress: entry.registeredAddress,
			status: entry.status,
			ttKeyId: entry.ttKeyId,
			uen: entry.uen,
		}

	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view
	}

}

export default useOrgData
